import styled from "styled-components";

export const StudiesContainer = styled.div`
  margin-top: 100px;
  padding: 0 var(--container-pad);
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 600px) {
    margin-top: 70px;
  }
`;

export const StudiesBlock = styled.div``;

export const HeadText = styled.p`
  line-height: 1.2;
  font-size: clamp(28px, 4vw, 44px);
  text-align: center;
  color: var(--color-primary);
  font-weight: 800;
  letter-spacing: -0.5px;
  margin: 0 0 30px;

  ${StudiesBlock} & {
    margin-top: 80px;
  }

  @media (max-width: 600px) {
    margin-top: 60px;
  }
`;

export const StudiesBlockAround = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;

  a {
    text-decoration: none;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 28px;
  }
`;
